import {
  readSentryDsnEnvVar,
  readSentryEnvVar,
  roleManagerUrlEnvVar,
} from "@src/cloud-connect/feature-toggles/feature-toggles";
import { RolesPermissionsMap } from "../entities/roles-permissions-map";
import { PermissionsSetService } from "../services/permissions-set-service";
import { RolesPermissionsService } from "../services/roles-permissions-service";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import * as Sentry from "@sentry/browser";

export class LoadPermissionsFromApi {
  private rolesPermissionsService: RolesPermissionsService;
  private permissionsSetService: PermissionsSetService;
  private roles: string[];

  constructor(
    rolesPermissionsService: RolesPermissionsService = new RolesPermissionsService(),
    permissionsSetService: PermissionsSetService = new PermissionsSetService(),
    roles: string[],
  ) {
    this.rolesPermissionsService = rolesPermissionsService;
    this.permissionsSetService = permissionsSetService;
    this.roles = roles;
  }

  async execute(): Promise<boolean> {
    const logger = getLogger();
    const url = `${roleManagerUrlEnvVar()}/api/v1/roles`;

    logger.debug(url);

    try {
      const response = await fetch(url, { method: "GET" });

      if (!response.ok) {
        console.error("Failed to fetch roles from API:", response.statusText);
        throw new Error(
          `Failed to fetch roles from API: ${response.statusText}`,
        );
      }

      const data: RolesPermissionsMap = await response.json();

      this.rolesPermissionsService
        .getRolesPermissionsRepository()
        .setRolesPermissions(data);

      const permissionsSet =
        this.rolesPermissionsService.getPermissionsForRoles(this.roles);

      this.permissionsSetService.setPermissionsSet(permissionsSet);
      return true;
    } catch (error) {
      let err = error instanceof Error ? error : new Error(String(error));

      if (err instanceof TypeError && err.message === "Failed to fetch") {
        err = new Error(`Network error fetching roles from ${url}`);
      }

      Sentry.init({
        dsn: readSentryDsnEnvVar(),
        environment: readSentryEnvVar(),
      });

      Sentry.captureException(err);
      return false;
    }
  }
}
